export const statusOptions = [
  'ATOMIC',
  'BL / AWB / RCN',
  'CHEMICAL PERMIT',
  'EXEMPTION',
  'LCL SHIPMENT',
  'MISSING INFO / MANIFEST',
  'MISSING PERMIT',
  'MISSING / REVISED DOCS',
  'PVOC / TBS',
  'SHIPPING BILL INDIA',
  'TMDA PERMIT',
  'COMPLETE'
];

export const statusesRequireRemarks = [
  '/', 'MISSING', 'EXEMPTION'
];

// Invoicing page: only show released jobs whose Release Date is on/after this date
// (format: 'YYYY-MM-DD'). Jobs without a release date are still shown. Set to '' to disable.
export const INVOICING_RELEASED_JOBS_START_DATE = '2026-08-01';